export default __webpack_public_path__ + "static/media/bannerImg3.ec0e8427.png";